import { aceRaceRows } from "./aceResults";
import { computeLicensePoints } from "./drivers.util";

const keyOf = (value) => String(value ?? "").trim().replace(/^steam:/i, "").replace(/^S/i, "");
const isRace = (value) => ["R", "RACE"].includes(String(value || "").toUpperCase());

function addFinish(tally, position) {
  tally.finishes += 1;
  if (Number.isFinite(position) && position <= 3) tally.podiums += 1;
  if (position === 1) tally.wins += 1;
}

/** Build driver license totals across ACC, AC, and AC EVO race sessions. */
export function buildLicenseMapFromSessions({ accSessions = [], acSessions = [], aceSessions = [] }) {
  const totals = new Map();
  const ensure = (id) => {
    const key = keyOf(id);
    if (!key) return null;
    if (!totals.has(key)) totals.set(key, { finishes: 0, podiums: 0, wins: 0 });
    return totals.get(key);
  };

  for (const json of accSessions) {
    if (!json || !isRace(json?.sessionType ?? json?.Type)) continue;
    const lines = json?.sessionResult?.leaderBoardLines ?? [];
    lines.forEach((line, index) => {
      const tally = ensure(line?.currentDriver?.playerId || line?.car?.drivers?.[0]?.playerId);
      if (tally) addFinish(tally, index + 1);
    });
  }

  for (const json of acSessions) {
    if (!json || !isRace(json?.Type)) continue;
    const results = Array.isArray(json?.Result) ? json.Result : [];
    results.forEach((result, index) => {
      const tally = ensure(result?.DriverGuid);
      if (tally) addFinish(tally, index + 1);
    });
  }

  for (const json of aceSessions) {
    aceRaceRows(json).forEach((result) => {
      const tally = ensure(result.id);
      if (tally) addFinish(tally, result.position);
    });
  }

  return new Map(
    Array.from(totals, ([id, tally]) => [id, { ...tally, X: computeLicensePoints(tally) }])
  );
}
